import { activitySchemaProcessed } from '@eventr/common'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { z } from 'zod'
import { useEditItem } from '../hooks/useEditItem'
import { ActivityRoutes } from './routes'
export function getActivitySchema() {
    return activitySchemaProcessed
}
export type ActivityValidationSchema = z.infer<
    ReturnType<typeof getActivitySchema>
>

export const ActivityEditPage = () => {
    const { idItem } = useParams<{
        idItem: string
    }>()

    const item = useEditItem(8, idItem ?? '')
    const methods = useForm({
        resolver: zodResolver(getActivitySchema()),
        shouldFocusError: true,
    })

    useEffect(() => {
        methods.reset(item, {
            keepDirty: false,
        })
    }, [item, methods])

    return (
        <FormProvider {...methods}>
            <ActivityRoutes />
        </FormProvider>
    )
}
